import { Injectable, Optional, signal, SkipSelf, WritableSignal } from '@angular/core';

export interface ToastProps {
  id?: number;
  body: string;
  heading?: string;
  icon?: string;
  appearance?: string;
  duration?: number;
  position?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toasts: WritableSignal<ToastProps[]> = signal([]);
  private idCounter = 0;

  constructor() {}

  public showToast(
    body: string,
    heading: string = '',
    icon: string = '',
    appearance: string = 'neutral',
    position: string = 'top-center',
    duration: number = 3000
  ) {
    const id = ++this.idCounter;
    const toast: ToastProps = { id, heading, body, icon, appearance, duration, position };
    this.toasts.set([...this.toasts(), toast]);
  }

  public showSuccess(
    body: string = '',
    heading: string = '',
    icon: string = 'check-circle',
    position: string = 'top-center'
  ): void {
    this.showToast(body, heading, icon, 'success', position);
  }

  public showError(
    body: string = '',
    heading: string = '',
    icon: string = 'exclamation-circle',
    position: string = 'top-center'
  ): void {
    this.showToast(body, heading, icon, 'error', position);
  }

  public getToasts(): WritableSignal<ToastProps[]> {
    return this.toasts;
  }

  public clearNotification(id: number): void {
    this.toasts.set(this.toasts().filter((t) => t.id !== id));
  }

  public clearAll(): void {
    this.toasts.set([]);
  }
}
